/**
 * 学习乐园 · 排排序题材包：地支次序（paixu/pack-dizhi.js）
 * ---------------------------------------------------------------------------
 * 子丑寅卯辰巳午未申酉戌亥 12 个全量上场（全集就这十二个，不抽）。
 * 地支与生肖一一对应（子鼠、丑牛……），生肖包管「生肖次序」，本包管
 * 「地支字本身」——note 把时辰与对应生肖一起写上，排一遍等于把
 * 「子时 23~1 点」这套时间坐标过一遍。
 * items 顺序即正确答案；同包 face 不得重复（排序题天然满足）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.dizhi = {
    id: 'dizhi',
    name: '地支次序',
    hint: '子到亥十二个全量排回',
    cols: 4,
    winText: '子丑寅卯辰巳午未申酉戌亥——配上生肖就是子鼠丑牛寅虎卯兔，一天十二时辰也在这条线上。',
    items: [
      { face: '子', note: '子时 23~1 点，配鼠' },
      { face: '丑', note: '丑时 1~3 点，配牛' },
      { face: '寅', note: '寅时 3~5 点，配虎' },
      { face: '卯', note: '卯时 5~7 点，配兔' },
      { face: '辰', note: '辰时 7~9 点，配龙' },
      { face: '巳', note: '巳时 9~11 点，配蛇' },
      { face: '午', note: '午时 11~13 点，配马' },
      { face: '未', note: '未时 13~15 点，配羊' },
      { face: '申', note: '申时 15~17 点，配猴' },
      { face: '酉', note: '酉时 17~19 点，配鸡' },
      { face: '戌', note: '戌时 19~21 点，配狗' },
      { face: '亥', note: '亥时 21~23 点，配猪，十二支收尾' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
